import { tzFormatTime } from 'common/dates';
import { IconLightning } from 'lib/components/Icons/IconLightning';
import { Flex } from 'lib/index';
import React from 'react';
import { RiskLevel } from './LightningRiskChart.styles';
import { useRematchSelector } from 'models/rematchStore';

export function LightningRiskChartView() {
    const lightningRisk = useRematchSelector((state) => state.weather.lightningRisk) || [];
    return (
        <Flex>
            <IconLightning fill="white" />
            {lightningRisk.map((item) => (
                <RiskLevel key={item.tm} riskLevel={item.value}>
                    {tzFormatTime(item.tm)}
                </RiskLevel>
            ))}
        </Flex>
    );
}
